import { useContext, useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import jwt_decode from 'jwt-decode';
import useToken from '../account/login/useToken';
import { LeftMenuContext } from '../../context/leftMenu.context';

const permissions = {
  SALLINGGROUP: ['Matrix', 'Tests', 'Products', 'Components', 'Modules', 'Vendors', 'Product'],
  ADMINISTRATOR: ['Matrix', 'Tests', 'Products', 'Components', 'Modules', 'Vendors', 'Users', 'Configurations', 'Product'],
  VENDOR: ['Matrix', 'Tests', 'Components', 'Product'],
} as any;
const usePermission = () => {
  let routerHistory = useHistory();
  const { selectedMenuItem } = useContext(LeftMenuContext);
  const { userTokenInfo } = useToken();
  useEffect(() => {
    let page = null;
    if (selectedMenuItem) {
      switch (userTokenInfo['Role'].toString().toLocaleUpperCase()) {
        case 'SALLINGGROUP':
          page = (permissions['SALLINGGROUP'] as string[]).find((o) => o == selectedMenuItem);
          if (!page) {
            routerHistory.push('/matrix');
          }
          break;
        case 'ADMINISTRATOR':
          break;
        default:
          page = (permissions['VENDOR'] as string[]).find((o) => o == selectedMenuItem);
          if (!page) {
            routerHistory.push('/matrix');
          }
          break;
      }
    }
  }, [selectedMenuItem]);
  return {};
};
export default usePermission;
